// extracted by mini-css-extract-plugin
export default {"container":"container--2Wles","reject-call-large":"reject-call-large--1Yygg","reject-call-medium":"reject-call-medium--2zo_3","icon":"icon--1J1E8"};